import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Box, Heading, Image, Link, Text } from '@chakra-ui/react';
import './Dashboard.css';
const copy = {
    discordInvite: {
        header: 'Join us on Discord',
        body: `We’re building a network of students to connect and collaborate, network and build their careers, or just chat and share memes. `,
        buttonText: 'PathMatch Discord Server',
        buttonLink: 'https://discord.gg/V2qaRDHgYx'
    }
};
export default function DiscordInvite() {
    return (
        <Box className="boxContent">
            <Image w="100%" borderRadius="xl" src="/discord.svg" mb="4" />
            <Heading className="boxHeading" fontSize={{ base: '28px' }}>
                {copy.discordInvite.header}
            </Heading>
            <Text mt="2" mb="2" fontSize={{ base: '14px' }} lineHeight={{ base: '24px' }}>
                {copy.discordInvite.body}
            </Text>
            <Link href={copy.discordInvite.buttonLink} isExternal>
                {copy.discordInvite.buttonText}
                <ExternalLinkIcon mx="4px" mb="3px" />
            </Link>
        </Box>
    );
}
